import { ShelfComponentProps, store, ComponentDesc, ScreenComponentProps, SettingsComponentProps } from '../store';
import { ColumnsProps } from '../store';
import { flowRight } from 'lodash';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';
import { ItemTypes } from '../Constants';
import { createElement } from 'react';
import { Container } from '../layout';
import { shelfComponentStyles } from './common/styles';
import withStyles from 'react-jss';
import { observer } from 'mobx-react';

const svg = require('./icons/twenty5_twenty5.svg');

let defaultTemplate = {
    id: +new Date(),
    type: 'TwentyfiveFiftyTwentyfive',
    style: {},
    settings: {
        backgroundColor: '#fff',
        contentBackgroundColor: '#fff',
        padding: 0,
        color: '#000',
        columns: [[], [], []],
        widths: [25, 50, 25],
    },
};

let shelfComponent = flowRight([
    withStyles(shelfComponentStyles),
    DragSource(
        ItemTypes.COLUMN,
        {
            beginDrag(props, monitor, component): ComponentDesc<ColumnsProps> {
                let t = JSON.parse(JSON.stringify(defaultTemplate));
                t.id = +new Date();
                return t;
            },
        },
        (connect: DragSourceConnector, monitor: DragSourceMonitor) => {
            return {
                connectDragSource: connect.dragSource(),
                isDragging: monitor.isDragging(),
            };
        }
    ),
])((props: ShelfComponentProps<typeof shelfComponentStyles>) => {
    let { connectDragSource, isDragging, classes } = props;
    return connectDragSource(
        <div className={classes.outer}>
            <div className={classes.root}>
                <img src={svg} className={classes.image} />
            </div>
        </div>
    );
});

let screenComponent = (props: ScreenComponentProps<ColumnsProps>) => {
    return (
        <div
            style={{
                display: 'flex',
                backgroundColor: props.descriptor.settings.backgroundColor,
            }}>
            <div
                style={{
                    display: 'flex',
                    width: store.currentTemplate.pageSettings.width,
                    margin: '0 auto',
                    backgroundColor: props.descriptor.settings.contentBackgroundColor ? props.descriptor.settings.contentBackgroundColor : store.currentTemplate.pageSettings.backgroundColor,
                }}>
                {props.descriptor.settings.columns.map((c, i) => {
                    return (
                        <div
                            key={'col-' + i}
                            style={{
                                flexBasis: props.descriptor.settings.widths[i] + '%',
                                outline: '#757575 solid 1px',
                            }}>
                            <Container components={c} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

let emailComponent = (props: ScreenComponentProps<ColumnsProps>) => {
    return (
        <table
            style={{
                backgroundColor: props.descriptor.settings.backgroundColor,
                width: '100%',
            }}>
            <tbody>
                <tr>
                    <td>
                        <table
                            style={{
                                width: store.currentTemplate.pageSettings.width,
                                margin: '0 auto',
                            }}>
                            <tr>
                                {props.descriptor.settings.columns.map((c, i) => {
                                    return (
                                        <td style={{ width: props.descriptor.settings.widths[i] + '%' }}>
                                            {c.map((elem) => {
                                                let token = store.getComponentTokenByName(elem.type);
                                                let C = token.emailComponent ? token.emailComponent : token.screenComponent;
                                                return <C descriptor={elem} />;
                                            })}
                                        </td>
                                    );
                                })}
                            </tr>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};
let outlookComponent = (props: ScreenComponentProps<ColumnsProps>) => {
    return (
        <div style={{ display: 'flex' }}>
            {props.descriptor.settings.columns.map((c) => {
                return (
                    <div>
                        <div style={{ width: '25%' }}>
                            <Container components={c} />
                        </div>
                        <div style={{ width: '50%' }}>
                            <Container components={c} />
                        </div>
                        <div style={{ width: '25%' }}>
                            <Container components={c} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

let settingsComponent = (props: SettingsComponentProps<ColumnsProps>) => {
    return <button onClick={(e) => props.descriptor.settings.columns.push([])}>Add Column</button>;
};

store.registerComponent({
    name: 'TwentyfiveFiftyTwentyfive',
    type: 'column',
    shelfComponent: shelfComponent,
    screenComponent: observer(screenComponent),
    settingsComponent,
    emailComponent,
    defaultTemplate,
    svg,
});
